


export const UnauthorizedPage = () => {
    return (
        <div className="kl-unauthorized-container">
            <div className="kl-unauthorized-content">
                <h1 className="kl-unauthorized-title">Unauthorized</h1>
                <p className="kl-unauthorized-message">You do not have permission to view this page.</p>
                <button className="kl-unauthorized-btn" onClick={() => window.location.href = '/login'}>
                    Go to Login
                </button>
            </div>
        </div>
    );
}